import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ReviewInvoices({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <h3 className="pink-info-text">
              Only check this item if a balance is owed!!
            </h3>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              If you do not check this step the collections process WILL NOT
              START! If the tenant owes something please do check this item.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text red-info-heading">
              open this general ledger report and look for any repairs that have
              happened since the tenants move out. also text arwin to ensure all
              invoices are in if she did make ready.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              https://integrityoklahoma.appfolio.com/buffered_reports/170
            </p>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Users email - property manager"
              name="managerEmail"
            >
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Tenant Name" name="tenantName">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Property Name" name="propertyName">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ReviewInvoices;
